"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AuthService["default"];
  }
});
var _AuthService = _interopRequireDefault(require("./AuthService"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }